import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useRef, useEffect } from "react";
import { useGraphiQLActions, useGraphiQL } from "./provider.js";
import { STORAGE_KEY, URI_NAME, KEY_BINDINGS } from "../constants.js";
import { onEditorContainerKeyDown, getOrCreateModel, createEditor } from "../utility/create-editor.js";
import { clsx } from "clsx";
import { useMonaco } from "../stores/monaco.js";
import { useChangeHandler } from "../utility/hooks.js";
import { pick } from "../utility/pick.js";
import { cleanupDisposables } from "../utility/cleanup-disposables.js";
const VariablesEditor = (t0) => {
  const $ = c(15);
  const {
    onEdit,
    ...props
  } = t0;
  const {
    setEditor,
    run,
    prettifyEditors,
    mergeQuery
  } = useGraphiQLActions();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = pick("initialVariables", "uriInstanceId");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    initialVariables,
    uriInstanceId
  } = useGraphiQL(t1);
  const ref = useRef(null);
  const monaco = useMonaco(_temp);
  useChangeHandler(onEdit, STORAGE_KEY.variables, "variables");
  let t2;
  if ($[1] !== initialVariables || $[2] !== mergeQuery || $[3] !== monaco || $[4] !== prettifyEditors || $[5] !== run || $[6] !== setEditor || $[7] !== uriInstanceId) {
    t2 = () => {
      if (!monaco) {
        return;
      }
      const model = getOrCreateModel({
        uri: `${uriInstanceId}${URI_NAME.variables}`,
        value: initialVariables
      });
      const editor = createEditor(ref, {
        model
      });
      setEditor({
        variableEditor: editor
      });
      const disposables = [editor.addAction({
        ...KEY_BINDINGS.runQuery,
        run
      }), editor.addAction({
        ...KEY_BINDINGS.prettify,
        run: prettifyEditors
      }), editor.addAction({
        ...KEY_BINDINGS.mergeFragments,
        run: mergeQuery
      }), editor, model];
      return cleanupDisposables(disposables);
    };
    $[1] = initialVariables;
    $[2] = mergeQuery;
    $[3] = monaco;
    $[4] = prettifyEditors;
    $[5] = run;
    $[6] = setEditor;
    $[7] = uriInstanceId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== monaco) {
    t3 = [monaco];
    $[9] = monaco;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useEffect(t2, t3);
  const t4 = 0;
  const t5 = onEditorContainerKeyDown;
  const t6 = clsx("graphiql-editor", props.className);
  let t7;
  if ($[11] !== props || $[12] !== t5 || $[13] !== t6) {
    t7 = /* @__PURE__ */ jsx("div", { ref, tabIndex: t4, onKeyDown: t5, ...props, className: t6 });
    $[11] = props;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
function _temp(state) {
  return state.monaco;
}
export {
  VariablesEditor
};
//# sourceMappingURL=variables-editor.js.map
